module.exports = __webpack_public_path__ + "static/media/copyrightIco.a40ed363.png";